import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioAccesoService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'usuarios/accesos'); // La URL base para el servicio de lotes
  }


  getUsuariosAccesos(params) {
        return this.get<any[]>({ endpoint: ``, params })
    }
}
